import { Box, Typography } from "@mui/material";
import React, { useContext, useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { httpAPI_INQ002, httpAPI_INQ015 } from "./api/request";
import { GlobalContext } from "../../context/globalContext";
import TkTitle from "../../components/atoms/TkTitle";
import "./_style.scss";
import { TkGetCode } from "../../utils/TkGetCode";
import { changeAmountFormat, changeZipcodeFormat } from "../../utils/useTools";
import {
  CorpTypeList2,
  Prefectures,
  InquiryCode,
  DepositType,
} from "../../assets/data/Constants";
import TkButton from "../../components/atoms/TkButton";
import TkBackButton from "../../components/molecules/TkBackButton";
import { BusinessContext } from "../../context/businessContext";
import TkAccordion from "../../components/atoms/TkAccordion";
import authorityUserType from "../../assets/data/TkAuthorityProperty";
import { TkRouteContext } from "../../context/tkRouteContext";
import _ from "lodash";
import {
  cancelInfoList,
  commentHeader,
  historyHeader,
  inquiryList,
  returnStatusList,
  salaryList,
  staffList,
} from "./parts";
import { TkInquiryTable } from "./components/components";
import TkTable from "../../components/atoms/TkTable";
import { IAPI_INQ002_Response } from "../../type/apiType";
import TkTextArea from "../../components/molecules/TkTextArea";
import TkMessageDialog from "../../components/molecules/TkMessageDialog";

/**
 * SCRC040101 契約者照会
 * @return SCRC040101 契約者照会
 */
const SCRC040101 = () => {
  const navigate = useNavigate();

  const { state, setState } = useContext(GlobalContext);
  const [displayItem, setDisplayItem] = useState<any>();
  const { state: businessState, setState: setBusinessState } =
    useContext(BusinessContext);
  const isKiko =
    state.authInfo?.userType === authorityUserType.userTypeNumber.KIKO;
  const [initData, setInitData] = useState<IAPI_INQ002_Response>({});
  const [corpInfoList, setCorpInfoList] = useState(_.cloneDeep(inquiryList));
  const [staffInfoList, setStaffInfoList] = useState(_.cloneDeep(staffList));
  const [salaryInfoList, setSalaryInfoList] = useState(_.cloneDeep(salaryList));
  const [historyList, setHistoryList] = useState<any>([]);
  const [comment, setComment] = useState("");
  const [open, setOpen] = useState(false);

  const location = useLocation();
  const { state: routerState, setState: setRouterState } =
    useContext(TkRouteContext);
  const wantToSetInRouterList = useRef<any>(
    location.state?.wantToSetInRouterList ?? []
  );

  useEffect(() => {
    openingScreen();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (wantToSetInRouterList.current.length === 0) return;
    if (_.isEqual(wantToSetInRouterList.current, routerState.routerList))
      return;
    setRouterState({
      routerList: wantToSetInRouterList.current as any,
    });
  }, [wantToSetInRouterList, routerState.routerList, setRouterState]);

  async function openingScreen() {
    try {
      const res = await httpAPI_INQ002({
        contractorNo: isKiko
          ? businessState?.job_114?.contractorNo ??
            businessState.common?.contractorNo
          : state.authInfo?.contractorNo,
      });

      if (res.resultCd === "I0000") {
        // 契約者情報
        let resArr = [...corpInfoList];
        for (let i in res) {
          resArr.forEach((item) => {
            let targetObj = item.find((v) => v.keyword === i)!;

            if (targetObj) {
              if (
                i === "contractorNo" ||
                i === "corpNameKana" ||
                i === "corpName"
              ) {
                targetObj.fill = res.corpApplyKbn === "無";
              }
              if (i === "businessOwnerClass") {
                targetObj.text = TkGetCode(
                  CorpTypeList2,
                  res.businessOwnerClass
                );
                return;
              }
              if (i === "corpName") {
                targetObj.lock = res.reserveFlg === "1";
              }
              targetObj.text = res[i as keyof typeof res];
            }
          });
        }
        resArr.forEach((item) => {
          let address = item.find((i) => i.keyword === "address")!;
          if (address) {
            address.text = (
              <>
                {"〒" + (changeZipcodeFormat(res.zipcode) ?? "")}
                <br />
                {(TkGetCode(Prefectures, res.prefectureCd) ?? "") +
                  (res.addressCity ?? "") +
                  (res.addressOthers ?? "")}
              </>
            );
          }
        });
        setCorpInfoList([...resArr]);

        // 職員状況
        let stfArr = [...staffInfoList];
        stfArr.forEach((item) => {
          let staffNum = item.find((v) => v.keyword === "staffNum")!;
          let staffNumNow = item.find((v) => v.keyword === "staffNumNow")!;

          if (staffNum) {
            staffNum.text =
              (res.staffNum ?? "") +
              "人(福祉:" +
              (res.staffNumSocial ?? "") +
              "人　介護:" +
              (res.staffNumCare ?? "") +
              "人（うち補助対象:" +
              (res.staffNumCareAuxiliary ?? "") +
              "人）　申出:" +
              (res.staffNumProposal ?? "") +
              "人（うち補助対象:" +
              (res.staffNumProposalAuxiliary ?? "") +
              "人））";
          }
          if (staffNumNow) {
            staffNumNow.text =
              (res.staffNumNow ?? "") +
              "人(福祉:" +
              (res.staffNumNowSocial ?? "") +
              "人　介護:" +
              (res.staffNumNowCare ?? "") +
              "人（うち補助対象:" +
              (res.staffNumNowCareAuxiliary ?? "") +
              "人）　申出:" +
              (res.staffNumNowProposal ?? "") +
              "人（うち補助対象:" +
              (res.staffNumNowProposalAuxiliary ?? "") +
              "人））";
          }
        });
        setStaffInfoList(stfArr);

        // 調整額一覧
        let slyArr = [...salaryInfoList];
        for (let i in res) {
          slyArr.forEach((item) => {
            let targetObj = item.find((v) => v.keyword === i)!;

            targetObj && (targetObj.text = res[i as keyof typeof res]);
          });
        }
        setSalaryInfoList(slyArr);

        // 法人情報変更履歴
        const historyList: any = [];
        res.contractorHistoryList?.forEach((item) => {
          if (item.addressChangeDate) {
            const addressChangeLog = [
              { children: item.addressChangeDate },
              { children: "契約者の所在地" },
              {
                children: (
                  <>
                    <Box>
                      {item.bZipcode
                        ? "〒" + changeZipcodeFormat(item.bZipcode)
                        : ""}
                    </Box>
                    <Box>
                      {(TkGetCode(Prefectures, item.bPrefectureCd) ?? "") +
                        (item.bAddressCity ?? "") +
                        (item.bAddressOthers ?? "")}
                    </Box>
                  </>
                ),
              },
              {
                children: (
                  <>
                    <Box>
                      {item.aZipcode || item.bZipcode
                        ? "〒" +
                          changeZipcodeFormat(item.aZipcode ?? item.bZipcode)
                        : ""}
                    </Box>
                    <Box>
                      {(TkGetCode(
                        Prefectures,
                        item.aPrefectureCd ?? item.bPrefectureCd
                      ) ?? "") +
                        (item.aAddressCity ?? item.bAddressCity ?? "") +
                        (item.aAddressOthers ?? item.bAddressOthers ?? "")}
                    </Box>
                  </>
                ),
              },
            ];
            historyList.push(addressChangeLog);
          }
          if (item.nameChangeDate) {
            const nameChangeLog = [
              { children: item.nameChangeDate },
              { children: "契約者の名称" },
              {
                children: (
                  <>
                    <Box>{item.bCorpNameKana ?? ""}</Box>
                    <Box>{item.bCorpName ?? ""}</Box>
                  </>
                ),
              },
              {
                children: (
                  <>
                    <Box>{item.aCorpNameKana ?? item.bCorpNameKana ?? ""}</Box>
                    <Box>{item.aCorpName ?? item.bCorpName ?? ""}</Box>
                  </>
                ),
              },
            ];
            historyList.push(nameChangeLog);
          }
          if (item.aBusinessOwnerClass) {
            const classChangeLog = [
              { children: item.nameChangeDate },
              { children: "経営者の種別" },
              {
                children: TkGetCode(CorpTypeList2, item.bBusinessOwnerClass),
              },
              {
                children: TkGetCode(CorpTypeList2, item.aBusinessOwnerClass),
              },
            ];
            historyList.push(classChangeLog);
          }
        });
        setHistoryList(historyList);

        // 収納状況
        const receiveInfoAccordionContents = !!res.receiveStatusList && (
          <Box className="tkTable">
            {res.receiveStatusList.map((status, index) => (
              <React.Fragment key={index}>
                <Box className="tkTableLine">
                  <Box className="tkBoxArea">
                    <Box className="tkTitleNoBox">
                      <Typography>{"種類"}</Typography>
                    </Box>
                    <Box className="tkBodyNoBox">
                      <Typography>{status.invoiceKbn}</Typography>
                    </Box>
                  </Box>
                </Box>
                <Box className="tkTableLine">
                  <Box className="tkBox">
                    <Box className="tkTitle">
                      <Typography>{"過納/未納ステータス"}</Typography>
                    </Box>
                    <Box className="tkBody">
                      <Typography>{status.receiveStatus}</Typography>
                    </Box>
                  </Box>
                  <Box className="tkBox">
                    <Box className="tkTitle">
                      <Typography>{"過納/未納額"}</Typography>
                    </Box>
                    <Box className="tkBody">
                      <Typography>{status.overpayAmtOrUnpaidAmt}</Typography>
                    </Box>
                  </Box>
                </Box>
                <Box className="container">
                  <Box className="tkColumnLeft">
                    <Box className="tkTableLine">
                      <Box className="tkBoxArea">
                        <Box className="tkTitle">
                          <Typography>{"請求期限"}</Typography>
                        </Box>
                        <Box className="tkBody">
                          <Typography>{status.dueDate}</Typography>
                        </Box>
                      </Box>
                    </Box>
                    <Box className="tkTableLine">
                      <Box className="tkBoxArea">
                        <Box className="tkTitle">
                          <Typography>{"請求金額"}</Typography>
                        </Box>
                        <Box className="tkBody">
                          <Typography>{status.invoiceAmt}</Typography>
                        </Box>
                      </Box>
                    </Box>
                  </Box>
                  <Box className="tkColumnRight">
                    <Box className="tkTableLine">
                      <Box className="tkHeadTableDeposit">
                        <Box className="tkTitle">
                          <Typography>{"入金日　入金金額"}</Typography>
                        </Box>
                        <Box className="tkBody">
                          {status.depositDateList &&
                            status.depositDateList.map((deposit, idx) => (
                              <Box key={idx}>
                                <Typography>{`${deposit.depositDate}　${deposit.amt}`}</Typography>
                              </Box>
                            ))}
                        </Box>
                      </Box>
                    </Box>
                  </Box>
                </Box>
              </React.Fragment>
            ))}
          </Box>
        );

        // 解除情報
        let canArr = [...cancelInfoList];
        for (let i in res) {
          canArr.forEach((item) => {
            let targetObj = item.find((v) => v.keyword === i)!;

            if (targetObj) {
              targetObj.text = res[i as keyof typeof res];
            }
          });
        }

        // 収納状況
        let retArr = [...returnStatusList];
        for (let i in res.returnStatusList?.[0]) {
          retArr.forEach((item) => {
            let targetObj = item.find((v) => v.keyword === i)!;

            if (targetObj) {
              if (i === "deposit_type") {
                targetObj.text = TkGetCode(
                  DepositType,
                  res.returnStatusList?.[0]?.[i]
                );
                return;
              }
              if (i === "transferAmt") {
                targetObj.text = changeAmountFormat(
                  res.returnStatusList?.[0]?.[i] ?? 0
                );
                return;
              }
              targetObj.text =
                res.returnStatusList?.[0]?.[
                  i as keyof (typeof res.returnStatusList)[0]
                ];
            }
          });
        }

        const showTable = (
          <Box className="tkItems" data-testid="SCRC040101PageItems">
            {!!res.cancelDate && (
              <Box className="tkTable">
                <TkAccordion
                  title="解除情報"
                  titleClassName="tkLineTitle"
                  children={<TkInquiryTable list={canArr} />}
                />
              </Box>
            )}

            {res?.receiveStatusList && res?.receiveStatusList?.length > 0 && (
              <Box className="tkTable">
                <TkAccordion
                  title="収納状況"
                  titleClassName="tkLineTitle"
                  children={receiveInfoAccordionContents}
                />
              </Box>
            )}

            {!!res.returnStatusList?.length && (
              <Box className="tkTable">
                <TkAccordion
                  title="返戻状況"
                  titleClassName="tkLineTitle"
                  children={<TkInquiryTable list={retArr} />}
                />
              </Box>
            )}
          </Box>
        );
        setDisplayItem(showTable);

        setInitData(res);
        setState({
          ...state,
          errorMsgId: "",
        });
      } else {
        setState({ ...state, errorMsgId: res.resultCd });
      }
    } catch (error) {
      navigate("/error");
    }
  }

  const handleUpdateClick = () => {
    if (!comment.match(/^([^ -~｡-ﾟ])*$/)) return;

    setOpen(true);
  };

  const handleCommentUpdate = async () => {
    // 照会用コメント更新API 呼び出し
    try {
      const res = await httpAPI_INQ015({
        contractorNo: initData.contractorNo,
        inquiryCode: InquiryCode["契約者"],
        refComment: comment,
      });

      if (res.resultCd === "I0000") {
        setState({
          ...state,
          errorMsgId: "",
        });
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    } finally {
      setOpen(false);
    }
  };

  const handleMoveCorpList = () => {
    setBusinessState({
      ...businessState,
      job_114: {
        ...businessState.job_114,
        searchContractorNo: initData.contractorNo,
        searchResultDisplayTarget: "2",
        detailDisplayCd: "1",
      },
    });
    navigate("/SCRW120002");
  };

  const handleMoveStaffList = () => {
    setBusinessState({
      ...businessState,
      job_114: {
        ...businessState.job_114,
        searchContractorNo: initData.contractorNo,
        searchResultDisplayTarget: "3",
        detailDisplayCd: "3",
      },
    });
    navigate("/SCRW120002");
  };

  return (
    <Box data-testid="SCRC040101PageForTest" className="tkSCRC040101">
      <Box className="tkTitleCenter">
        <TkTitle children={"契約者照会"} size="large" />
      </Box>

      <TkInquiryTable tableTitle="契約者情報" list={corpInfoList} />

      {isKiko && (
        <Box className="comments">
          <Box className="tkLineTitle">{"追記情報"}</Box>
          <TkTable
            headList={commentHeader}
            bodyList={[
              [
                {
                  children: (
                    <TkTextArea
                      onlyFullWidth
                      inputProps={{ maxLength: 2000 }}
                      wantToSetValue={initData.refComment}
                      onChange={(e: any) => setComment(e.target.value)}
                    />
                  ),
                },
              ],
            ]}
          />
          <Box className="button">
            <TkButton onClick={handleUpdateClick}>コメント更新</TkButton>
          </Box>
        </Box>
      )}

      {displayItem}

      <TkInquiryTable tableTitle="職員状況" list={staffInfoList} />

      <TkInquiryTable tableTitle="調整額一覧" list={salaryInfoList} />

      <Box className="tkLineTitle">{"法人情報変更履歴"}</Box>
      <TkTable headList={historyHeader} bodyList={historyList} />

      {isKiko && (
        <Typography className="fileLink">{`¥¥10.4.2.74¥document¥${initData.contractorNo}`}</Typography>
      )}

      <Box className="tkBtnArea">
        <TkBackButton />
        {isKiko && (
          <>
            <TkButton onClick={handleMoveCorpList}>{"施設一覧"}</TkButton>
            <TkButton onClick={handleMoveStaffList}>{"職員一覧"}</TkButton>
          </>
        )}
      </Box>

      <TkMessageDialog
        open={open}
        onOky={handleCommentUpdate}
        onCancel={() => setOpen(false)}
        title="更新"
        contextText="　コメントを更新しますが、問題ないでしょうか。"
        cancelText="いいえ"
        okText="はい"
      />
    </Box>
  );
};

export default SCRC040101;
